import type { CustomAuth0Settings } from '@white-label-types/auth';
import { Auth0Client } from '@auth0/auth0-spa-js';

/**
 * Redirects the user to the Auth0 login page.
 * @async
 * @param {CustomAuth0Settings} customAuth0Settings - Custom brand settings for Auth0 login page
 * @returns {Promise<void>}
 */
export const loginWrapper = async (
  auth0Client: Auth0Client | null,
  customAuth0Settings: CustomAuth0Settings
) => {
  await auth0Client?.loginWithRedirect({
    authorizationParams: {
      ...customAuth0Settings,
    },
  });
};
